import DevStorage from '@/services/storage/Dev';
import ProdStorage from '@/services/storage/Prod';
import FileStorage from '@/entities/FileStorage';

const accessKeyId = process.env.VUE_APP_LOCAL_S3_ACCESS_KEY_ID;
const secretAccessKey = process.env.VUE_APP_LOCAL_S3_SECRET_ACCESS_KEY;
const S3bucketURL = process.env.VUE_APP_LOCAL_S3BUCKET_URL;

const storage: FileStorage =
	accessKeyId && secretAccessKey && S3bucketURL
		? new DevStorage({
				S3bucketURL,
				S3config: {
					accessKeyId,
					secretAccessKey,
				},
		  })
		: new ProdStorage();

export default storage;
